import {DEVICE_PIXEL_RATIO} from 'ol/has';

export const FERTILITY_RATE_COLORS = {
    "150 or more births per 1,000": "#e93a2a",
    "125-149 births per 1,000": "#fa8d35",
    "100-124 births per 1,000": "#f6e962",
    "75-99 births per 1,000": "#a0c29b",
    "Fewer than 75 births per 1,000": "#2892c7",
};

export const CHANGE_AMT_COLORS = {
    'Decrease of over -15%': "#e93a2a",
    'Decrease between -6% and -15%': "#fa8d35",
    'Change between -5% and 5%': "#f6e962",
    'Increase between 6% and 15%': "#a0c29b",
    'Increase of over 15%': "#2892c7",
}

export const CATEGORIZED_CHANGE_COLORS = {
    'Low fertility, decrease': '#2792c6',
    'Low fertility, little change': '#8db8a4',
    'Low fertility, increase': '#d7e27c',
    'High fertility, decrease': '#fdcf50',
    'High fertility, little change': '#f77a32',
    'High fertility, increase': '#e8392a',
}

export const adolescentBirthRadiusMap = value =>
{
    if (typeof(value)!=='number') return null;
    const pixelRatio = DEVICE_PIXEL_RATIO;
    return (value < 500) ?
        1*pixelRatio :
        (value < 1000) ?
        2*pixelRatio :
        (value < 2499) ?
        3*pixelRatio
        :(value < 4999) ?
        4*pixelRatio :
        5*pixelRatio;
};

export const adolescentBirthColorMap = (value) =>
{
    if (typeof(value)!=='number') return null;
    return (value < 1000) ? 'blue': 'yellow';
}

export const birthDiffColorMap = value =>
{
    if (typeof(value)!=='number') return null;
    return (value < -25) ? "#e93a2a"
        : (value < -5) ? "#fa8d35"
        : (value < 5) ? "#f6e962"
        : (value < 25) ? "#a0c29b"
        : "#2892c7";
}

export const populationColorMap = value =>
{
    if (typeof(value)!=='number') return null;
    return (value < 40000) ? "#2892c7"
        : (value < 100000) ? "#a0c29b"
        : (value < 500000) ? "#f6e962"
        : (value < 2000000) ? "#fa8d35"
        : "#e93a2a";
}

export const getLegendUrl = (colors) =>
{
    const cellSize = 20;
    const padding = 5;
    const canvas = document.createElement('canvas');
    canvas.width = 220;
    canvas.height = cellSize * Object.keys(colors).length + 2 * padding;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.textBaseline = 'middle';
    ctx.font = '12.5px Arial';
    Object.keys(colors).forEach((label, index) =>
    {
        const y = padding + cellSize * index;
        ctx.fillStyle = colors[label];
        ctx.fillRect(padding, y, cellSize, cellSize);
        ctx.fillStyle = 'black';
        ctx.fillText(label, padding * 2 + cellSize, y + cellSize / 2);
    });

    return {
        dataurl: canvas.toDataURL(),
        width: canvas.width,
        height: canvas.height,
    };
};

export const getAdolescentBirthLegendUrl = (radii) =>
{
    // console.assert(this.series && this.data && this.colors, 'Either Series or Data or Colors is not setup!')
    const cellSize = 20;
    const padding = 5;
    const canvas = document.createElement('canvas');
    canvas.width = 220;
    canvas.height = cellSize * Object.keys(radii).length + 2 * padding;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.textBaseline = 'middle';
    ctx.font = '12.5px Arial';
    Object.keys(radii).forEach((label, index) =>
    {
        const y = padding + cellSize * index;
        const radius = radii[label];
        ctx.fillStyle = radius < 3*DEVICE_PIXEL_RATIO ? 'black': 'yellow';
        ctx.beginPath();
        ctx.arc(padding +cellSize/2, y+cellSize/2-2, radius, 0, 2 * Math.PI);
        ctx.fill();
        ctx.stroke();
        
        ctx.fillStyle = 'black';
        ctx.fillText(label, padding * 2 + cellSize, y + cellSize / 2);
    });

    return {
        dataurl: canvas.toDataURL(),
        width: canvas.width,
        height: canvas.height,
    };
};

export const fertilityRateLegendURL = getLegendUrl({
    "150 or more births per 1,000": "#e93a2a",
    "125-149 births per 1,000": "#fa8d35",
    "100-124 births per 1,000": "#f6e962",
    "75-99 births per 1,000": "#a0c29b",
    "Fewer than 75 births per 1,000": "#2892c7",
});

export const fertilityRateLegendURLNepali = getLegendUrl({
    "प्रति हजार १५० वा बढी जन्म": "#e93a2a",
    "प्रति हजार १२५-१५० जन्म": "#fa8d35",
    "प्रति हजार १००-१२४ जन्म": "#f6e962",
    "प्रति हजार ७५-९९ जन्म": "#a0c29b",
    "प्रति हजार ७५ जन्म भन्दा कम": "#2892c7",
});

export const changeAmtLegendURL = getLegendUrl({
    'Decrease of over 15%': "#e93a2a",
    'Decrease between 6% and 15%': "#fa8d35",
    'Change between -5% & 5%': "#f6e962",
    'Increase between 6% and 15%': "#a0c29b",
    'Increase of over 15%': "#2892c7",
});

export const changeAmtLegendURLNepali = getLegendUrl({
    '-१५% बढिको घट्ने': "#e93a2a",
    '-६% देखि -१५% बिचको घट्ने': "#fa8d35",
    '-५% देखि ५% बिचको परिवर्तन': "#f6e962",
    '६% देखि १५% बिचको बढ्ने': "#a0c29b",
    '१५% बढीको बढ्ने': "#2892c7",
});

export const birthDiffLegendURL = getLegendUrl({
    '< -25%': "#e93a2a",
    '-25% to -5%': "#fa8d35",
    '-5% to 5%': "#f6e962",
    '5% to 25%': "#a0c29b",
    '>= 25%': "#2892c7",
});


export const birthDiffLegendURLNepali = getLegendUrl({
    '< -२५%': "#e93a2a",
    '-२५% देखि -५%': "#fa8d35",
    '-५% देखि ५%': "#f6e962",
    '५% देखि २५%': "#a0c29b",
    '>= २५%`': "#2892c7",
});

// export const populationLegendURL = getLegendUrl({
//     "0 - 40000": "#2892c7",
//     "40000 - 100000": "#a0c29b",
//     "100000 - 500000": "#f6e962",
//     "500000 - 2000000": "#fa8d35",
//     "2000000 Above": "#e93a2a",
// })

export const adolescentBirthLegendURL = getAdolescentBirthLegendUrl({
    "<= 499": (1 * DEVICE_PIXEL_RATIO),
    "500 - 999": (2 * DEVICE_PIXEL_RATIO),
    "1000 - 2499": (3 * DEVICE_PIXEL_RATIO),
    "2500 - 4999": (4 * DEVICE_PIXEL_RATIO),
    ">=5000": (5 * DEVICE_PIXEL_RATIO),
});

export const adolescentBirthLegendURLNepali = getAdolescentBirthLegendUrl({
    "<= ४९९": (1 * DEVICE_PIXEL_RATIO),
    "५०० - ९९९": (2 * DEVICE_PIXEL_RATIO),
    "१००० - २४९९": (3 * DEVICE_PIXEL_RATIO),
    "२५०० - ४९९९": (4 * DEVICE_PIXEL_RATIO),
    ">=५०००": (5 * DEVICE_PIXEL_RATIO),
});

export const categorizedChangeLegendURL = getLegendUrl({
    'Low fertility, decrease': '#2792c6',
    'Low fertility, little change': '#8db8a4',
    'Low fertility, increase': '#d7e27c',
    'High fertility, decrease': '#fdcf50',
    'High fertility, little change': '#f77a32',
    'High fertility, increase': '#e8392a',
});

export const categorizedChangeLegendURLNepali = getLegendUrl({
    'कम प्रजनन्, घट्ने': '#2792c6',
    'कम प्रजनन्, सानो परिवर्तन': '#8db8a4',
    'कम प्रजनन्, बढ्ने': '#d7e27c',
    'बढी प्रजनन्, घट्ने': '#fdcf50',
    'बढी प्रजनन्, सानो परिवर्तन': '#f77a32',
    'बढी प्रजनन्, बढ्ने': '#e8392a',
});

export const slantLinePatternColor = (function () {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const pixelRatio = DEVICE_PIXEL_RATIO;
    canvas.width = 5 * pixelRatio;
    canvas.height = 5 * pixelRatio;
    // white background
    context.fillStyle = 'white';
    context.fillRect(0, 0, canvas.width, canvas.height);
    // outer stripe line
    context.fillStyle = 'black';
    context.beginPath();
    context.moveTo(0, 0);
    context.lineTo(canvas.width, canvas.height);
    context.stroke();
    return context.createPattern(canvas, 'repeat');
})();

